import { Type } from 'class-transformer';
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
import { ProjectTaskRawDto } from './project-task-raw-dto';

export class ProjectTaskEditorResultDto {
    @Type(() => ProjectTaskRawDto)
    projectTask: ProjectTaskRawDto;

    @Type(() => KeyValueResultDto)
    statusList: KeyValueResultDto[];

    @Type(() => Date)
    enteredOn: Date;

    enteredBy: string;
    hasNotes: boolean;
    invalidResponsibleUserWarning: boolean;
    allowAddWorkOrder: boolean;
}
